module.exports = __webpack_public_path__ + "img/dash-square.302878e8.svg";